import React from 'react';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../../definitions/constants';

import GlassPopup from '../interface/glassPopup';
import File from '../inputs/file';
import CheckBox from '../inputs/checkBox';
import ErrorFeedback from '../feedback/errorFeedback';

const EntityImportFormPopup = props => {
  const {
    handleShowPopup,
    handleDownloadImportSheet,
    handleButton,
    loadingButton,
    fullLoading,
    statusButton,
    formData,
    errors,
    entityNamePlural,
    genderVocal,
    popupState,
    additionalControls
  } = props;
  return (
    <GlassPopup
      className="form_popup import_form_popup"
      title={(<FormattedMessage 
         id="common.entity.importEntitiesWithName"
         values={{entityNamePlural: entityNamePlural}}
       />)}
      buttonText={(<FormattedMessage 
         id="common.entity.importEntitiesWithName"
         values={{entityNamePlural: entityNamePlural}}
       />)}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
      />
      {additionalControls}
      <p className="form_paragraph">
        <FormattedMessage 
          id="common.entity.importDownloadLinkDescription"
          values={{entityNamePlural: entityNamePlural}}
        />
        {": "}
        <a onClick={handleDownloadImportSheet}>
          <FormattedMessage id="common.entity.importLinkDownload"/>
        </a>
      </p>
      <CheckBox
        className="after_form_paragraph_options"
        id="import_include_deactivated"
        labelLocale={<FormattedMessage 
          id="common.entity.includeDeactivated"
          values={{genderVocal: genderVocal}}                       
        />}
      />
      <label className="form_info">
        <FormattedMessage 
          id={"common.entity.importHelpMessage"}        
          values={{entityNamePlural: entityNamePlural}}
        />
      </label>
      <File
        id="import_file"
      />
    </GlassPopup>
  );
};

export default EntityImportFormPopup;



// WEBPACK FOOTER //
// ./source/client/components/common/entity/entityImportFormPopup.jsx